import { gql } from '@apollo/client';

export const GET_FAIR_CODE = gql`
    query GetFairCode {
        getFairCode {
            code
            contactId
            createdAt
            updatedAt
            startDate
            endDate
        }
    }
`;
